<h2 mat-dialog-title>Créer une nouvelle grille de vente</h2>
<mat-dialog-content>
    <form [formGroup]="usageRateForm">
        <mat-form-field class="w-full">
            <mat-label>Type</mat-label>
            <mat-select formControlName="is_landline">
                <mat-option [value]="false"><mat-icon>smartphone</mat-icon> Mobile</mat-option>
                <mat-option [value]="true"><mat-icon>phone</mat-icon> Fixe</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Nom</mat-label>
            <input matInput type="text" formControlName="name">
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Description</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" formControlName="description"></textarea>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Service</mat-label>
            <mat-select formControlName="service">
                @for (service of services; track service.name) {
                <mat-option [value]="service.name">{{ service.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <div class="my-4">
            <mat-slide-toggle formControlName="is_exception">Grille d'exception</mat-slide-toggle>
        </div>

        @if (usageRateForm.get('is_exception')?.value == true) {
        <mat-form-field class="w-full">
            <mat-label>Type d'exception</mat-label>
            <mat-select formControlName="type">
                <mat-option>Non spécifié</mat-option>
                @for (exceptionType of exceptionTypes | keyvalue; track exceptionType.key) {
                <mat-option [value]="exceptionType.key">{{ exceptionType.value }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        }

        @if (usageRateForm.get('is_exception')?.value == false) {
        <div class="my-4">
            <mat-slide-toggle formControlName="is_default">Grille par défaut</mat-slide-toggle>
        </div>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]>Annuler</button>
    <button matButton (click)="submit()">Valider</button>
</mat-dialog-actions>